__turbopack_context__.v({
  "card": "Services-module-scss-module__IH_9CW__card",
  "cardBullet": "Services-module-scss-module__IH_9CW__cardBullet",
  "cardBulletIcon": "Services-module-scss-module__IH_9CW__cardBulletIcon",
  "cardsGrid": "Services-module-scss-module__IH_9CW__cardsGrid",
  "cardsSection": "Services-module-scss-module__IH_9CW__cardsSection",
  "details": "Services-module-scss-module__IH_9CW__details",
  "detailsImage": "Services-module-scss-module__IH_9CW__detailsImage",
  "detailsText": "Services-module-scss-module__IH_9CW__detailsText",
});
